// src/api/services/farm/farmService.js
import client from '../client';

const BASE = '/api/farmsearch';

/**
 * Search farms by text query
 * verbose: default = false,
 * query, page, limit 
 * @param {
 *   verbose?: boolean, 
 *   query?: string,
 *   distance?: number,
 *   categoryId?: number,
 *   featureId?: number,
 *   verified?: boolean,
 *   minRating?: number,
 *   hasBanner?: boolean,
 *   page?: number,
 *   limit?: number,
 *   sort?: string,
 *   order?: 'ASC'|'DESC'
 * } query
 * @return
 */
export function searchFarmsByText(query) {
  return client
    .get(`${BASE}/textsearch`, { params: query })
    .then(res => {
      // res.data = { success, data: { items, meta }, meta }
      return {
        items: res.data?.data?.items ?? [],
        meta: res.data?.data?.meta ?? {}
      }
    })
}

/**
 * Find farms near a coordinate, with optional filters
 * @param {
 *   verbose?: boolean,
 *   latitude: number,
 *   longitude: number,
 *   distance?: number,
 *   categoryId?: number,
 *   featureId?: number,
 *   verified?: boolean,
 *   minRating?: number,
 *   hasBanner?: boolean,
 *   page?: number,
 *   limit?: number,
 *   sort?: string,
 *   order?: 'ASC'|'DESC'
 * } query
 * @return
 */
export function findFarmsByProximity(query) {
  return client
    .get(`${BASE}/proximitysearch`, { params: query })
    .then(res => {
      return {
        items: res.data?.data?.items ?? [],
        meta: res.data?.data?.meta ?? {}
      }
    })
}

/**
 * Find farms near a coordinate, with optional filters
 * @param {
 *   q: string
 * } query
 * @return
 */
export function findSuggest(query) {
  return client
    .get(`${BASE}/suggest`, { params: query })
    .then(res => {
      return {
        items: res.data?.data ?? [],
        meta: res.data?.meta ?? {}
      }
    })
    .catch(error => {
      throw error;
    })
}
